import React from 'react';
import styled from 'styled-components';

import { ReactComponent as ErrorIcon } from '../assets/img/icons/error.svg';
import { ReactComponent as SuccessIcon } from '../assets/img/icons/success.svg';
import GlobalStyle from './GlobalStyle';

const MSG_SUCCESS = '#E9FFF0'; // message success
const MSG_ERROR = '#FFF4E5';

const ErrorWrapper = styled.div<Props>`
  display: block;
  width: 100%;
  background: ${(props: Props) => (props.type === 'error' ? MSG_ERROR : MSG_SUCCESS)};
  padding: 20px 12px;
  border-radius: 8px;
  ${(props: Props) => (props.marginBottom ? `margin-bottom: ${props.marginBottom}px;` : '')}
  margin-top: 20px;
  @media all and (max-width: 1439px) {
    margin-top: 10px;
    padding: 10px 12px;
  }
  .inner-div {
    align-items: flex-start;
  }
  svg {
    float: left;
    display: inline;
    width: auto;
    margin-right: 10px;
  }
  .message-title {
    font-size: 12px;
    color: #1ec252;
    font-weight: 500;
    line-height: 16px;
    margin: 0;
    letter-spacing: -0.3px;
    span.success {
      color: #1ec252;
    }
    span.error {
      color: #ffa112;
    }
  }
  .message-description {
    color: #424b50;
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    letter-spacing: -0.4px;
  }
`;

type Props = {
  type: string;
  label?: string;
  message?: string;
  marginBottom?: string;
} & typeof defaultProps;

const defaultProps = {
  label: '',
  message: '',
  marginBottom: '',
};

const Message = function Message(props: Props) {
  const { type, label, message } = props;
  let icon;
  if (type === 'error') {
    icon = <ErrorIcon />;
  } else {
    icon = <SuccessIcon />;
  }
  return (
    <>
      <GlobalStyle />
      <ErrorWrapper {...props}>
        <div className="d-flex inner-div">
          <div className="flex-shrink-1">{icon}</div>
          <div className="flex-grow-1">
            <p className="message-title">
              <span className={type}>{label}</span>
            </p>
            <p className="message-description">{message}</p>
          </div>
        </div>
      </ErrorWrapper>
    </>
  );
};

Message.defaultProps = defaultProps;
export default Message;
